import { useDispatch } from 'react-redux';
import { examDelete } from '../../../redux/actions/exam/examActions';
import Alert from '../../../itrust_common/components/Alert';
import { humanize } from '../../../itrust_common/components/HelperFunctions';
import DateFormatView from '../../../itrust_common/components/others/DateFormatView';

export default function DeleteExamButton(props) {
  const { exam, children, onDeleteHook } = props;
  const dispatch = useDispatch()

  const handleExamDelete = (id) => {
    Alert.deleteConfirm(<div>
      This action cannot be undone. The exam of <strong>{humanize(exam.patient_attributes.name)}</strong> created on <strong><DateFormatView date={exam.exam_date} /></strong> by <strong>{humanize(exam.provider_name)}</strong> would be permanently deleted and won't be recovered back. Are you sure to delete it?
    </div>,
      (res) => {
        if (res) {
          dispatch(examDelete(id))
          onDeleteHook && onDeleteHook()
        }
      }
    )
  }

  return (
    <span className="pointer" onClick={() => handleExamDelete(exam.id)}>
      {children}
    </span>
  )
}
